<template>
  <v-dialog v-model="dialog" max-width="500" @click:outside="cancel" @keydown.esc="cancel">
    <v-card>
      <v-card-title class="orange header">
        <span class="headline white--text">
          <v-icon class="white--text">warning</v-icon>
          {{ title }}
        </span>
      </v-card-title>
      <v-card-text class="pa-3">
        <v-container class="text-left">
          <h2 class="font-weight-medium">{{ mainText }}</h2>
          <h5>{{ auxText }}</h5>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn width="100" depressed @click="cancel"><v-icon>close</v-icon></v-btn>
        <v-btn color="orange" class="light--text" depressed @click="confirm" width="100">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      msg: "",
      aux: false,
    };
  },
  props: {
    showDialog: {
      default: false,
      type: Boolean,
    },
    title: {
      default: "",
      type: String,
    },
    mainText: {
      default: "",
      type: String,
    },
    auxText: {
      default: "",
      type: String,
    },
  },
  watch: {
    showDialog() {
      this.dialog = this.showDialog;
    },
  },
  methods: {
    confirm() {
      this.dialog = false;
      this.$emit("closedDialog", true);
    },
    cancel() {
      this.dialog = false;
      this.$emit("closedDialog", false);
    },
  },
};
</script>
<style scoped>
.header span{
  font-size: 22px !important;
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 10px;
}
</style>
